import { Button } from "react-bootstrap"
import toast from "react-hot-toast"

import { useDeclineJoinClubRequestMutation } from "../../app/clubsApiSlice"
import LoadingTextSwap from "../LoadingTextSwap"
import useAuth from "../../hooks/useAuth"
import { useAdminNotificationsReadMutation } from "../../app/adminApiSlice"
import { useClubNotificationsReadMutation } from "../../app/clubsApiSlice"

const DeclineJoinClubRequestButton = ({ requestId, clubId, setDisableButtons, disableButtons }) => {
  const { role } = useAuth()
  const [declineJoinClubRequest] = useDeclineJoinClubRequestMutation()
  const [adminNotificationsRead] = useAdminNotificationsReadMutation()
  const [clubNotificationsRead] = useClubNotificationsReadMutation()

  const onButtonClick = async () => {
    try {
      setDisableButtons(true)

      if (role === "admin") {
        adminNotificationsRead({ requests: [requestId], messages: [] })
      } else {
        clubNotificationsRead({ requests: [requestId], messages: [], clubId })
      }
      await declineJoinClubRequest({ requestId, role, clubId }).unwrap()
      setDisableButtons(false)

    } catch (error) {
      console.error(error)

      if (error.data.message === "Request already accepted") {
        toast.error("This request has already been declined either by the club secretary or the admin team")
      } else {
        toast.error("Error declining request")
      }

      setDisableButtons(false)
    }
  }

  return (
    <Button disabled={disableButtons} variant="" className="w-50 rounded-3 bg-white border-light shadow-btn" onClick={onButtonClick}>
      <LoadingTextSwap isLoading={disableButtons}>
        Decline
      </LoadingTextSwap>
    </Button>
  )
}

export default DeclineJoinClubRequestButton